export default {
  id: 'kling-v3',
  nodeType: 'video',
  label: '可灵 V3',
  description: '可灵 V3 视频生成：文生 / 图生 / 首尾帧 / 动作控制，支持 720P/1080P/4K。',
}
